import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDomainTransferToCart } from "features/common/layouts/cartSlice";
import { addEpp } from "features/domain/domainsSlice";
import Spinner from "react-bootstrap/Spinner";
import {
  formatIDR,
  // useQuery 
} from "helpers/utils";
// import { useLocation } from "react-router-dom";
import { notifyError, notifyWarning, notifySuccess } from "components/ToastMessage";
import { hasFreeDomainInCart, getIsFreeDomain as getIsFreeDomainHelper } from "../../helpers/helpersSuccessDomain";
// import { getOnlyTLD } from "helpers/helper";
const SuccessDomainTransfer = (props) => {
  const { extensions = [], onToggleDomainSections } = props;
  const dispatch = useDispatch();
  // const location = useLocation();
  // const query = useQuery();
  const results = useSelector((state) => state.domain.domain_transfer);
  const { status } = useSelector((state) => state.domain);
  const cartItems = useSelector((state) => state.cart.productsList);
  // const { freeDomainExtensions } = useSelector((state) => state.hosting);
  const [epp, setEpp] = useState("");

  // const { domain, duration } = results[0] ?? { domain: "", duration: 0 };

  // Gunakan helper function untuk menentukan apakah domain gratis
  const getIsFreeDomain = (domain, duration, cartItems, isTransfer = false) => {
    return getIsFreeDomainHelper(domain, duration, cartItems, isTransfer);
  };

  // Check if any domain can be transferred (status "not-available" and not in pending states)
  const hasTransferableDomain = results.some(result => 
    result.status === "not-available" && 
    !result.whois.includes("pendingDelete") && 
    !result.whois.includes("redemptionPeriod")
  );

  // Handle "Isi Domain Nanti" button click
  const handleIsiDomainNanti = () => {
    if (onToggleDomainSections) {
      // Hide the domain sections permanently
      onToggleDomainSections(false);
    }
  };

  const addDomainToCartHandler = (e) => {
    const availableDomains = results.filter(
      (result) => result.status === "not-available"
    );
    availableDomains.forEach((result, i) => {
      if (!epp) {
        notifyError(`Masukkan Kode EPP Domain Anda!`);
        return;
      } else {
        const { domain, status, price, duration } = result;
        if (cartItems.find((list) => list.domain === domain)) {
          notifyWarning("Domain Anda sudah berada didalam keranjang.");
          return;
        }

        const isDomainFree = getIsFreeDomain(domain, duration, cartItems, true);
        const hasExistingFreeDomain = hasFreeDomainInCart(cartItems);
        const finalPrice = (isDomainFree && !hasExistingFreeDomain) ? 0 : price;

        dispatch(addEpp({ epp, domain: domain }));
        dispatch(
          addDomainTransferToCart({
            name: domain,
            price: finalPrice,
            status,
            domain: domain,
            type: "transfer",
            eppCode: epp,
            duration: duration,
            isFreeDomain: isDomainFree
          })
        );
        notifySuccess("Domain berhasil ditambahkan ke keranjang.");
      }
    });
  };

  // Auto-open domain sections when transferable domains are found - DISABLED
  // useEffect(() => {
  //   if (hasTransferableDomain && onToggleDomainSections) {
  //     onToggleDomainSections(true); // Open domain sections
  //   }
  // }, [hasTransferableDomain, onToggleDomainSections]);

  return (
    <>
      {status === "loading" && (
        <div className="text-center my-5">
          <Spinner animation="border" />
        </div>
      )}
      {status === "error" && (
        <div>An error occurred. Please try again later.</div>
      )}
      {status === "fulfilled" && (
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-12">
              {results.map((result, i) => (
                <div key={i}>
                  {/* Case 1: Domain bisa ditransfer */}
                  {result.status === "not-available" &&
                    (!result.whois.includes("pendingDelete") &&
                      !result.whois.includes("redemptionPeriod")) && (
                      <div className="my-4">
                        <div className="row align-items-center mb-4">
                          <div className="col-12 col-lg-6">
                            <p className="mb-0 text-primary fw-bold h5">
                              {result.domain}
                            </p>
                          </div>
                          <div className="col-12 col-lg-6 text-lg-end">
                            {(() => {
                              const isDomainFree = getIsFreeDomain(result.domain, result.duration, cartItems, true);
                              const hasExistingFreeDomain = hasFreeDomainInCart(cartItems);
                              return (isDomainFree && !hasExistingFreeDomain) ? (
                                <div className="d-flex flex-column align-items-end">
                                  <span className="text-muted small fw-bold text-decoration-line-through">
                                    {formatIDR(result.price)}
                                  </span>
                                  <div className="d-flex flex-column align-items-end">
                                    <span className="fw-bold">{formatIDR(0)}</span>
                                    <span className="badge bg-success text-white p-2 mt-1">
                                      GRATIS DOMAIN!
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <p className="mb-0 fw-bold h5">
                                  {formatIDR(result.price)}
                                </p>
                              );
                            })()}
                          </div>
                        </div>

                        {/* EPP Code Input */}
                        <div className="mb-4">
                          <label htmlFor="epp-code" className="form-label fw-bold">
                            EPP Code
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="epp-code"
                            placeholder="Masukkan Kode EPP"
                            onChange={(e) => setEpp(e.target.value)}
                          />
                          <div className="form-text mt-2">
                            Informasi Kode EPP Dapat Dilihat Pada Registrar Domain Anda Sebelumnya.
                          </div>
                        </div>

                        {/* Tombol */}
                        <div className="text-end">
                          <button
                            className="btn btn-cta px-4 rounded-5"
                            onClick={hasTransferableDomain ? addDomainToCartHandler : handleIsiDomainNanti}
                          >
                            {hasTransferableDomain ? "Tambahkan ke Keranjang" : "Isi Domain Nanti"}
                          </button>
                        </div>
                      </div>
                    )}

                  {/* Case 2: Domain dalam status pending/redemption */}
                  {(result.whois.includes("pendingDelete") ||
                    result.whois.includes("redemptionPeriod")) && (
                      <div className="mt-3">
                        <h5 className="text-not-available">
                          {result.domain} berstatus pending delete atau redemption
                        </h5>
                      </div>
                    )}

                  {/* Case 3: Domain error transfer */}
                  {result.status === "error" && (
                    <div className="mt-3">
                      <h5 className="text-not-available mx-auto">
                        {result.domain} tidak dapat ditransfer. Silakan cek status domain Anda.
                      </h5>
                    </div>
                  )}

                  {/* Case 4: Domain available */}
                  {result.status === "available" && (
                    <div className="mt-3">
                      <h5 className="text-not-available">
                        {result.domain} tidak dapat ditransfer karena domain belum terdaftar
                      </h5>
                    </div>
                  )}

                  {/* Separator jika ada multiple domains */}
                  {results.length > 1 && i < results.length - 1 && (
                    <hr className="mt-3" />
                  )}
                </div>
              ))}
              
              {/* Fallback button when no transferable domains are found - DISABLED */}
              {/* {results.length > 0 && !hasTransferableDomain && (
                <div className="text-center my-4">
                  <button
                    className="btn btn-cta px-4 rounded-5"
                    onClick={handleIsiDomainNanti}
                  >
                    Isi Domain Nanti
                  </button>
                </div>
              )} */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessDomainTransfer;
